import { FC } from "react";
import { EDetailSection } from "@/models/common/enums";
import { useRouter } from "next/router";
import { useIsMD, useIsSM } from "@/utils/hooks/useWindowSizes";
import PackageDetailNavbarItem from "@/components/detail/PackageDetailNavbarItem";
import { useStore } from "@/store/index";
import { formatPrice } from "@/utils/common/formatPrice";
import { useCurrency } from "@/utils/hooks/useCurrency";
import { useCurrencyConversion } from "@/utils/hooks/useCurrencyConversion";
import styles from "../../styles/detail/DetailRecap.module.scss";

const PackageDetailNavbar: FC<{
    showAccomodations?: boolean;
    isRequestAQuote: boolean;
    handleNavigation: (el: EDetailSection) => void;
}> = ({ showAccomodations = true, handleNavigation, isRequestAQuote }) => {
    const router = useRouter();

    const totalAmount = useStore(
        state => state.checkoutState.orderData.totalAmount
    );

    const isSM = useIsSM();
    const isMD = useIsMD();

    const { clickConfirmDate } = useStore(state => state.checkoutState);
    const { currency } = useCurrency();
    const { convertPrice } = useCurrencyConversion();

    return (
        <div className={`w-100 ${styles.customContainer}`}>
            <div className={styles.customContainerInner}>
                <div className="d-flex justify-content-between align-items-center">
                    <PackageDetailNavbarItem
                        thisSection={EDetailSection.GENERAL}
                        handleNavigation={handleNavigation}
                        title="General Info"
                    />
                    <PackageDetailNavbarItem
                        thisSection={EDetailSection.ITINERARY}
                        handleNavigation={handleNavigation}
                        title="Itinerary"
                    />

                    {showAccomodations && (
                        <PackageDetailNavbarItem
                            thisSection={EDetailSection.ACCOMMODATION}
                            handleNavigation={handleNavigation}
                            title="Accommodations"
                        />
                    )}

                    <PackageDetailNavbarItem
                        thisSection={EDetailSection.HIW}
                        handleNavigation={handleNavigation}
                        title="How It Works"
                    />

                    <span
                        className={
                            useIsSM() ? styles.spanNav : styles.spanNavFaq
                        }
                        onClick={() => router.push("/faq")}
                    >
                        F.A.Q.
                    </span>
                </div>
                {!isSM && !isMD && !isRequestAQuote && (
                    <div className={styles.priceSection}>
                        <div className="d-flex flex-row gap-2">
                            <span className={styles.priceSectionPriceLegend}>
                                {/* {!clickConfirmDate || !isDefault
                                    ? "Your package price: "
                                    : ""} */}
                                Your package price:
                            </span>
                            <span className={styles.priceSectionPrice}>
                                {clickConfirmDate && totalAmount
                                    ? formatPrice(
                                          parseFloat(convertPrice(totalAmount)),
                                          currency
                                      )
                                    : "-"}
                            </span>

                            {/* <span className={styles.priceSectionPriceLegend}>
                                {isDefault && clickConfirmDate
                                    ? "/person (starting price)"
                                    : ""}
                            </span> */}
                        </div>
                    </div>
                )}
                {!isRequestAQuote && (
                    <div
                        className={
                            !isSM
                                ? clickConfirmDate
                                    ? styles.reserveButton
                                    : styles.reserveButtonDisabled
                                : `d-none`
                        }
                        onClick={() =>
                            clickConfirmDate &&
                            handleNavigation(EDetailSection.GENERAL)
                        }
                    >
                        <span>Reserve</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PackageDetailNavbar;
